export const newsItems = [
  {
    id: "n1",
    title: "2026暑期档观察：国产科幻与古装双线发力，票房口碑齐升",
    date: "2026-08-18",
    category: "行业观察",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20editorial%20banner%20of%20a%20modern%20cinema%20lobby%20with%20warm%20lights%20and%20rows%20of%20posters%2C%20amber%20and%20deep%20blue%20tones%2C%20editorial%20photography%20style%2C%20clean%20composition%2C%20no%20text&width=1200&height=675&seq=tianlang-n1&orientation=landscape",
    summary:
      "今年暑期档国产影片表现亮眼，科幻与古装两条赛道同时发力，多部作品在票房和口碑上取得双丰收，观众对本土类型片的信心持续提升。",
    content:
      "随着暑期档进入尾声，今年的成绩单逐渐清晰。与往年不同，今年国产影片在题材上呈现出更加多元的探索：科幻类型在工业化制作上继续突破，古装题材则在叙事与美学上带来新的惊喜。\n\n业内分析认为，观众的口味正在从'看热闹'向'看质量'转变。一部影片能否获得长线放映，越来越取决于真实口碑的传播速度，而不再仅仅依赖首周的热度堆积。\n\n与此同时，影院端的排片策略也更加灵活。多部中小成本影片通过精准的口碑营销，在强片环伺的档期中找到了属于自己的观众群体，形成了良性的差异化竞争。\n\n展望接下来的国庆档与贺岁档，市场普遍预期热度将延续。对于观众而言，这无疑是一个内容供给愈发丰富的好时代。",
    relatedIds: ["m1", "m2", "t1"],
  },
  {
    id: "n2",
    title: "《流浪地球3》发布首支预告：地球引擎迎来终极考验",
    date: "2026-07-30",
    category: "新片资讯",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20editorial%20banner%2C%20massive%20planetary%20engine%20towers%20glowing%20against%20a%20dark%20blue%20sky%20with%20sparks%2C%20epic%20scale%2C%20dramatic%20lighting%2C%20no%20text&width=1200&height=675&seq=tianlang-n2&orientation=landscape",
    summary:
      "备受期待的科幻续作正式放出首支预告片，地球引擎的全新设定与更宏大的场面引发广泛讨论，影片定档消息同步公布。",
    content:
      "预告片以一段低沉的环境音开场，随后画面的信息量迅速攀升。与系列前作相比，这一部在视效层面明显更进一步，行星发动机的规模感与细节质感都得到了强化。\n\n创作团队透露，影片在剧本阶段就确立了'以人为核心'的创作方向。再宏大的灾难，最终落点依然是个体的选择与情感，这也是系列一贯打动观众的地方。\n\n预告发布后，社交平台上关于剧情走向的猜测层出不穷。官方并未透露过多细节，只表示'这一部会给整个系列一个阶段性的答案'。\n\n影片的正式上映日期已经公布，更多幕后花絮与主创访谈也将陆续释出。",
    relatedIds: ["m1", "m9"],
  },
  {
    id: "n3",
    title: "现实题材持续走热：从《狂飙》到《漫长的季节》的叙事转向",
    date: "2026-06-22",
    category: "深度解读",
    cover: "https://readdy.ai/api/search-image?query=moody%20cinematic%20editorial%20banner%20of%20a%20rainy%20city%20street%20at%20night%20with%20warm%20streetlamps%2C%20teal%20and%20amber%20tones%2C%20film%20grain%20atmosphere%2C%20no%20text&width=1200&height=675&seq=tianlang-n3&orientation=landscape",
    summary:
      "近年来，一批扎根现实、刻画普通人的剧集获得了现象级关注。它们以扎实的剧本和细腻的人物，重新定义了什么叫做'好看'。",
    content:
      "如果把近几年的高分剧集放在一起看，会发现一个共同的趋势：它们都愿意花时间在'人'身上。无论是一线刑警还是小城青年，角色不再是推动情节的工具，而是有血有肉的个体。\n\n这种转向背后，是创作者对观众审美变化的敏锐捕捉。当信息获取变得空前便利，观众对'套路'的耐受度越来越低，反而对真实、克制、有质感的表达更加买账。\n\n制作层面，这类作品往往选择实地取景、精简特效，把更多资源投入到表演和节奏的打磨上。看似'朴实'，实则对细节的要求更高。\n\n可以预见，现实题材仍将是未来一段时间内的创作富矿，但如何在真实与戏剧性之间找到平衡，依然是每一位创作者需要回答的命题。",
    relatedIds: ["t1", "t3", "t5"],
  },
  {
    id: "n4",
    title: "古装权谋再出爆款：《庆余年2》如何延续系列口碑",
    date: "2026-05-14",
    category: "剧集评论",
    cover: "https://readdy.ai/api/search-image?query=elegant%20ancient%20chinese%20palace%20corridor%20at%20dawn%20with%20red%20lanterns%2C%20crimson%20and%20gold%20editorial%20banner%2C%20cinematic%20composition%2C%20no%20text&width=1200&height=675&seq=tianlang-n4&orientation=landscape",
    summary:
      "作为系列续作，《庆余年2》在保留原有喜剧节奏的同时，将权谋的复杂度进一步提升，角色群像的刻画成为最大亮点。",
    content:
      "续作最难的地方，在于既要满足老观众的期待，又要让新观众看得进去。《庆余年2》选择的方式是：把世界观铺得更开，同时把人物的动机埋得更深。\n\n剧中最受好评的部分，依然是主角与配角之间你来我往的对手戏。台词的机锋、表演的分寸，共同撑起了这些场景的张力。\n\n在节奏上，剧集前半段侧重铺设，后半段逐渐收紧，几场关键戏份的处理都相当克制，留白恰到好处。\n\n对于喜欢权谋题材的观众来说，这是一部值得慢慢品的作品；而对于只看热闹的观众，它同样提供了足够多的笑点与爽点。",
    relatedIds: ["t6", "t4"],
  },
  {
    id: "n5",
    title: "幕后揭秘：一部悬疑剧的声音设计是怎么炼成的",
    date: "2026-04-09",
    category: "幕后花絮",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20editorial%20banner%20of%20a%20sound%20studio%20mixing%20console%20with%20glowing%20meters%2C%20dark%20interior%20with%20warm%20accents%2C%20moody%20atmosphere%2C%20no%20text&width=1200&height=675&seq=tianlang-n5&orientation=landscape",
    summary:
      "悬疑剧的紧张感，有一半来自声音。本文走进幕后，聊聊那些看不见的层次如何一步步构建出让观众屏息的氛围。",
    content:
      "很多人以为悬疑靠的是画面，其实声音才是那个'隐形的主角'。一段恰到好处的环境音，往往比一个惊悚镜头更能让人后背发凉。\n\n声音团队介绍，他们的工作从读剧本就开始。哪些地方需要留白，哪些地方要用低频铺底，哪些瞬间需要一记短促的提示音，都要提前规划。\n\n在混音阶段，对白、音效、配乐三条线需要反复平衡。一个常见的原则是：越是接近真相的时刻，声音反而越要收，让观众听见自己的心跳。\n\n正是这些看不见的功夫，构成了观剧体验中那些'说不上来但就是很紧张'的瞬间。",
    relatedIds: ["t3", "t5", "m7"],
  },
  {
    id: "n6",
    title: "动画电影的新表达：《深海回响》用画面讲一个成长的故事",
    date: "2026-03-02",
    category: "新片资讯",
    cover: "https://readdy.ai/api/search-image?query=dreamy%20animated%20editorial%20banner%20with%20flowing%20teal%20and%20coral%20color%20clouds%20underwater%2C%20glowing%20particles%2C%20painterly%20style%2C%20no%20text&width=1200&height=675&seq=tianlang-n6&orientation=landscape",
    summary:
      "作为一部风格鲜明的国产动画，《深海回响》用绚烂的视觉语言包裹了一个关于告别与成长的温柔内核，收获了大量好评。",
    content:
      "动画的魅力，在于它可以把难以言说的情绪具象化。《深海回响》正是这样一部作品：它用流动的色彩和光影，去描摹一个孩子内心的孤独与勇气。\n\n技术上，影片对流体与粒子的呈现达到了相当高的水准，但创作者始终强调，视觉是为情感服务的。每一帧绚烂的画面背后，都能对应到角色当下的心理状态。\n\n故事本身并不复杂，却足够真诚。它没有刻意煽情，而是把情绪一点点积累，在结尾处自然释放，让不少观众红了眼眶。\n\n对于国产动画而言，这既是一次技术上的展示，也是一次叙事上的成熟。",
    relatedIds: ["m6", "m1"],
  },
  {
    id: "n7",
    title: "影市观察：小成本影片如何靠口碑撬动长线放映",
    date: "2026-02-11",
    category: "行业观察",
    cover: "https://readdy.ai/api/search-image?query=warm%20cozy%20small%20independent%20cinema%20interior%20with%20red%20seats%20and%20soft%20lighting%2C%20editorial%20banner%2C%20clean%20composition%2C%20no%20text&width=1200&height=675&seq=tianlang-n7&orientation=landscape",
    summary:
      "没有大明星、没有大制作，一些小成本影片却凭借真实的口碑实现了逆袭。本文分析了这种'长线放映'现象背后的逻辑。",
    content:
      "过去，一部影片的命运往往在首周就基本确定。但近几年，越来越多的案例表明，口碑正在成为决定长线表现的关键变量。\n\n这些小成本影片的共同点是：它们精准地找到了自己的核心观众，并通过社交媒体上的自发传播不断破圈。观众不再只是被动的接受者，而成了内容的二次传播者。\n\n对影院而言，灵活调整排片、给予优质中小片更多机会，也在客观上促成了这种良性循环。\n\n当然，口碑逆袭从来不是设计出来的，它的前提永远是作品本身足够扎实。",
    relatedIds: ["m11", "m12", "m10"],
  },
  {
    id: "n8",
    title: "题材融合新趋势：当悬疑遇上喜剧，观众为什么买账",
    date: "2026-01-16",
    category: "深度解读",
    cover: "https://readdy.ai/api/search-image?query=playful%20neon-lit%20city%20alley%20at%20night%20with%20signs%20in%20amber%20and%20teal%2C%20mysterious%20yet%20fun%20editorial%20banner%2C%20no%20text&width=1200&height=675&seq=tianlang-n8&orientation=landscape",
    summary:
      "悬疑与喜剧的结合，曾经被认为是收视毒药，如今却接连诞生爆款。这种反差的搭配，究竟满足了观众怎样的心理需求？",
    content:
      "悬疑让人紧张，喜剧让人放松，看似矛盾的两者，放在一起却产生了奇妙的化学反应。\n\n心理学上的解释是：情绪的起伏需要对比。如果全程紧绷，观众容易疲劳；而适时的幽默，可以让紧张感得到释放，从而在下一个悬念到来时重新拉满。\n\n成功的融合，考验的是创作者的节奏掌控力。笑点不能喧宾夺主，也不能生硬插入，必须与剧情和人物融为一体。\n\n可以预见，未来会有更多创作者尝试跨类型的组合，但能否像这些作品一样让观众真正买单，仍然取决于故事本身是否扎实。",
    relatedIds: ["m5", "m9", "m11"],
  },
];